import React from 'react';

import styles from './style.css';

const Noise = () => (
  <div className={styles.noise}>
    <div className={styles.noise__inner} />
  </div>
);

export default Noise;
